"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.actionTypes = void 0;
var actionTypes = {
  SUCCESS: "@@surveys/success",
  ERROR: "@@surveys/error",
  SURVEY_LOGIN: "@@surveys/login",
  SURVEY_RESET: "@@surveys/reset",
  LOCKED_OUT: "@@auth/locked-out",
  SURVEY_FORGOT_PASSWORD: "@@surveys/forgotPassword",
  SURVEY_EXPIRY_MAGIC_LINK_PASSWORD: "@@surveys/expiryMagicLinkPassword",
  SURVEY_DETAILS: "@@surveys/surveyDetails",
  PUBLIC_DETAILS: "@@surveys/publicDetails",
  EMAIL_PROVIDER: "@@surveys/email-provider"
};
exports.actionTypes = actionTypes;